import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addOrUpdateQualifyQuestion } from "../../../../redux/featuresSlice/commonSlice";
import Header from "../../../../components/Header/Header";
import images from "../../../../images";
import { useNavigate, useLocation } from "react-router-dom";
import YesNoQuestion from "./yesnoQuetion";
import { useTranslation } from "react-i18next";

const QualifyQuestion = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [questionNumber, setQuestionNumber] = useState(1);
  const [, setQuestions] = useState([]);

  useEffect(() => {
    if (location.state) {
      if (location.state.questionText) {
        setQuestionText(location.state.questionText);
      }
      if (location.state.questionNumber) {
        setQuestionNumber(location.state.questionNumber);
      }
      if (location.state.questions) {
        setQuestions(location.state.questions);
      }
    }
  }, [location.state]);

  const handleBackClick = () => {
    navigate("/ondemand?step=4");
  };

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  const handleQuestionTextChange = (e) => {
    const newText = e.target.value;
    setQuestionText(newText);
  };
  const optionYesNo = [
    { option_text: t("base.yes"), value: "Yes" },
    { option_text: t("base.no"), value: "No" },
  ];
  const handleNextClick = () => {
    const formData = {
      id: questionNumber.toString(),
      title: `${t("quest.question")} ${questionNumber}`,
      question: questionText,
      options: optionYesNo,
      completed: true,
    };

    dispatch(addOrUpdateQualifyQuestion(formData));

    navigate("/ondemand?step=4");
  };

  return (
    <main className="flex flex-col min-h-screen">
      <div className="sticky top-0 left-0 w-full bg-[#3F54DF] z-50">
        <Header
          title={`${t("quest.question")} ${questionNumber}`}
          backIcon={images.BackIcon}
          onBackClick={handleBackClick}
          textColor="text-white"
        />
      </div>

      <div className="p-4 bg-gray-100 flex flex-col">
        <div className="bg-white rounded-lg shadow-sm mb-4">
          <div className="p-4">
            <textarea
              className="w-full text-gray-800 text-base resize-none border-0 focus:ring-0 focus:outline-none"
              placeholder={t("quest.enterYourQuestionHere")}
              value={questionText}
              onChange={handleQuestionTextChange}
              rows={3}
            />
          </div>
        </div>

        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-blue-600 font-medium">
              {t("base.options")}
            </span>
            <div className="flex items-center bg-yellow-50 rounded-md px-3 py-1">
              <span className="text-sm text-gray-700 mr-1">
                {t("base.yesno")}
              </span>
              <img
                src={images.ChevronDownIcon}
                alt="Dropdown"
                className="w-4 h-4"
              />
            </div>
          </div>

          <YesNoQuestion
            selectedOption={selectedOption}
            onOptionChange={handleOptionChange}
          />
        </div>

        <div className="flex-grow"></div>
      </div>

      <div className="p-4 bg-white border-t border-gray-200">
        <button
          onClick={handleNextClick}
          className="w-full bg-[#3F54DF] text-white py-3 rounded-full font-medium"
        >
          {t("base.next")}
        </button>
      </div>
    </main>
  );
};

export default QualifyQuestion;
